import { render, staticRenderFns } from "./r-stash-bonus-bunch-panel.vue?vue&type=template&id=74b9add1"
import script from "./r-stash-bonus-bunch-panel.vue?vue&type=script&lang=js"
export * from "./r-stash-bonus-bunch-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74b9add1')) {
      api.createRecord('74b9add1', component.options)
    } else {
      api.reload('74b9add1', component.options)
    }
    module.hot.accept("./r-stash-bonus-bunch-panel.vue?vue&type=template&id=74b9add1", function () {
      api.rerender('74b9add1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/stash/r-stash-bonus-bunch-panel.vue"
export default component.exports